export const weixin = {
  var: 'wx',
  version: {
    latest: '//res.wx.qq.com/open/js/jweixin-1.4.0.js'
  }
};

export const knb = {
  var: 'KNB',
  version: {
    latest: '//s0.meituan.net/bs/knb/v1.7.1/knb.js'
  }
};

export const weibo = {
  var: 'WeiboJS',
  version: {
    latest: '//tjs.sjs.sinajs.cn/open/thirdpart/js/jsapi/mobile.js'
  }
};

export const iFingerprint = {
  var: 'iFingerprint',
  version: {
    latest: '//s0.meituan.net/mxx/y/default.js'
  }
};
